import React from "react";
import {
  CheckCircle2,
  XCircle,
  Package,
  Truck,
  AlertTriangle,
  Skull,
  CalendarDays,
  BarChart3,
  CalendarPlus,
  Clock,
  Ban,
  Crown,
  Banknote,
  Cake,
  PartyPopper,
  TrendingUp,
  TrendingDown,
  PieChart,
  CreditCard,
  ShoppingCart,
  Tags,
  Trash2,
  RefreshCcw,
  Bot,
  Star,
  Timer,
  Hourglass,
  Armchair,
  ClipboardList,
  Gift,
  Users,
  Lightbulb,
  Target,
  Music,
  ChefHat,
  MonitorSmartphone,
  BellRing,
} from "lucide-react";
import { NotificationType } from "../../types/notifications.types";

interface NotificationIconProps {
  type: NotificationType | string;
  className?: string;
  icon?: string;
}

export const NotificationIcon: React.FC<NotificationIconProps> = ({
  type,
  className = "w-5 h-5",
}) => {
  switch (type as string) {
    // ORDER
    case "ORDER_READY":
      return <CheckCircle2 className={className} />;
    case "ORDER_CANCELLED":
      return <XCircle className={className} />;
    case "DELIVERY_DISPATCHED":
      return <Package className={className} />;
    case "DELIVERY_DELIVERED":
      return <Truck className={className} />;

    // INVENTORY
    case "LOW_STOCK_ALERT":
      return <AlertTriangle className={className} />;
    case "CRITICAL_STOCK":
    case "OUT_OF_STOCK":
      return <Skull className={className} />;
    case "EXPIRY_WARNING":
      return <CalendarDays className={className} />;
    case "STOCK_IMBALANCE":
      return <BarChart3 className={className} />;

    // BUSINESS
    case "NEW_RESERVATION":
      return <CalendarPlus className={className} />;
    case "RESERVATION_ARRIVAL":
      return <Clock className={className} />;
    case "NO_SHOW_ALERT":
      return <Ban className={className} />;
    case "VIP_CUSTOMER":
      return <Crown className={className} />;
    case "DAILY_REVENUE_SUMMARY":
      return <Banknote className={className} />;

    // LOYALTY
    case "BIRTHDAY_REMINDER":
      return <Cake className={className} />;
    case "LOYALTY_TIER_UPGRADE":
      return <PartyPopper className={className} />;

    // REVENUE
    case "REVENUE_MILESTONE":
      return <TrendingUp className={className} />;
    case "PEAK_HOURS_ALERT":
      return <TrendingUp className={className} />;
    case "LOW_REVENUE_WARNING":
      return <TrendingDown className={className} />;
    case "P_AND_L_SUMMARY":
      return <PieChart className={className} />;
    case "PAYMENT_FAILED":
      return <CreditCard className={className} />;
    case "CONSUMPTION_BUDGET":
      return <BarChart3 className={className} />;

    // SUPPLIER
    case "PO_SENT_TO_SUPPLIER":
      return <ShoppingCart className={className} />;
    case "STOCK_RECEIVED":
      return <Truck className={className} />;
    case "BEST_PRICE_ALERT":
      return <Tags className={className} />;
    case "SUPPLIER_DELAY":
      return <AlertTriangle className={className} />;
    case "SUPPLIER_PERFORMANCE":
      return <BarChart3 className={className} />;

    // MENU
    case "WASTAGE_DETECTED":
      return <Trash2 className={className} />;
    case "CONSUMPTION_VS_BUDGET":
      return <TrendingDown className={className} />;
    case "STOCK_MOVEMENT_ALERT":
      return <RefreshCcw className={className} />;
    case "MENU_PERFORMANCE":
      return <BarChart3 className={className} />;
    case "AI_MENU_SUGGESTION":
      return <Bot className={className} />;
    case "RECIPE_COST_CHANGE":
      return <Banknote className={className} />;
    case "PRICING_OPTIMIZATION":
      return <TrendingUp className={className} />;
    case "POPULAR_ITEM_ALERT":
      return <Star className={className} />;

    // TABLE
    case "TABLE_TURNOVER":
      return <Timer className={className} />;
    case "LONG_SEATED_CUSTOMER":
      return <Hourglass className={className} />;
    case "HIGH_OCCUPANCY_ALERT":
      return <Armchair className={className} />;
    case "RESERVED_TABLE_REMINDER":
      return <ClipboardList className={className} />;

    // CUSTOMER
    case "REPEAT_MILESTONE":
      return <RefreshCcw className={className} />;
    case "CUSTOMER_ANNIVERSARY":
      return <Gift className={className} />;
    case "CUSTOMER_FEEDBACK":
      return <Users className={className} />;
    case "REPEAT_PREFERENCE":
      return <Lightbulb className={className} />;

    // MARKETING
    case "CAMPAIGN_ACTIVE":
      return <Target className={className} />;
    case "DEAL_PERFORMANCE":
      return <BarChart3 className={className} />;
    case "EVENT_ATTENDANCE":
      return <Music className={className} />;

    // OPERATIONAL
    case "QUALITY_ISSUE":
      return <AlertTriangle className={className} />;
    case "STAFF_ALERT":
      return <ChefHat className={className} />;
    case "CRITICAL_ERROR":
      return <AlertTriangle className={className} />;
    case "SYSTEM_HEALTH":
      return <MonitorSmartphone className={className} />;

    default:
      if (type === "today" || type === "tomorrow" || type === "upcoming") {
        return <Cake className={className} />;
      }
      return <BellRing className={className} />;
  }
};
